import MkuCol from '../grid/col';

MkuCol.install = function (Vue) {
  Vue.component(MkuCol.name, MkuCol);
};

export default MkuCol;
